import { c as _c } from "react/compiler-runtime";
import { createQueryFn, marketplaceQueryKeys } from '../../../../lib/entry.js';
import { useSuspenseQuery } from '../../../../tanstack/entry.js';
import { getRetailerBalance } from '../../../actions/marketplace/getRetailerBalance.js';
const fetcher = createQueryFn(getRetailerBalance);
/**
 * Gets retailer balance for a given activated draw ID.
 *
 * @param activatedDrawId Activated draw ID to get retailer balance for
 * @param queryOptions Optional query configuration options
 * @returns Retailer balance model
 */
export function useGetRetailerBalance(activatedDrawId, queryOptions) {
  const $ = _c(8);
  let t0;
  if ($[0] !== activatedDrawId) {
    t0 = marketplaceQueryKeys.retailerBalance(activatedDrawId);
    $[0] = activatedDrawId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = queryOptions?.defaultValue;
  let t2;
  if ($[2] !== t1) {
    t2 = fetcher({
      defaultValue: t1
    });
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== queryOptions || $[5] !== t0 || $[6] !== t2) {
    t3 = {
      ...queryOptions,
      queryKey: t0,
      queryFn: t2
    };
    $[4] = queryOptions;
    $[5] = t0;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useSuspenseQuery(t3);
}